import { SITE_URL, socialImageUrl } from './site.js';

export const SEO_BY_ROUTE = {
    '/': {
        title: 'Alister Bryan | Fotografia e Cinema em São Paulo',
        description: 'Portfólio de Alister Bryan: fotografia, filmes e narrativas visuais com estética cinematográfica em São Paulo e região.',
    },
    '/gallery': {
        title: 'Galeria | Alister Bryan Fotografia e Cinema',
        description: 'Explore retratos, eventos, arte, cenas urbanas e projetos autorais selecionados do portfólio de Alister Bryan.',
    },
    '/services': {
        title: 'Serviços | Fotografia e Produção Audiovisual',
        description: 'Conheça os serviços de fotografia e produção audiovisual de Alister Bryan e solicite uma proposta para o seu projeto.',
    },
    '/about': {
        title: 'Sobre | Alister Bryan',
        description: 'Conheça o olhar de Alister Bryan, seu processo entre observação documental e direção cinematográfica, e os projetos que constroem sua linguagem visual.',
    },
    '/contact': {
        title: 'Contato | Alister Bryan',
        description: 'Fale com Alister Bryan sobre retratos, eventos, projetos autorais e produções audiovisuais em São Paulo e região.',
    },
    '/404': {
        title: 'Página não encontrada | Alister Bryan',
        description: 'A página solicitada não existe ou foi movida.',
        noindex: true,
    },
};

export const getSeoForPath = (pathname) => {
    if (pathname.startsWith('/admin')) {
        return {
            title: 'Studio Access | Alister Bryan',
            description: 'Área administrativa do portfólio Alister Bryan.',
            noindex: true,
        };
    }

    return SEO_BY_ROUTE[pathname] || SEO_BY_ROUTE['/404'];
};

export const buildSeo = (pathname) => {
    const normalizedPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
    const seo = getSeoForPath(normalizedPath);
    return {
        ...seo,
        canonical: `${SITE_URL}${normalizedPath === '/' ? '/' : normalizedPath}`,
        image: socialImageUrl,
    };
};
